import React from 'react';

const AnimatedIcon = ({ 
  icon: Icon, 
  className = "", 
  isActive = false, 
  isHovered = false,
  type = "default",
  ...props 
}) => {
  const getAnimationClasses = () => {
    if (type === "home" && isActive) {
      return "animate-pulse";
    }
    
    if (isHovered && !isActive) {
      return "transform transition-transform duration-200 hover:scale-110";
    }
    
    return "transition-all duration-200";
  };

  return (
    <Icon 
      className={`${className} ${getAnimationClasses()}`}
      {...props}
    />
  );
};

export default AnimatedIcon;